<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <Header/>

      <div class="row">
        <div class="col-xl-4">
          <b-card class="bCardGlobalXL mt-3" style="margin-right: -24px;height: 42vw">
            <div class="row" >
              <div class="text-left textSixe col-6">
                <span style="color:#4C9CCD">Listado de Kits</span>
              </div>
              <div class="text-right col-6">
                <b-button size="sm" pill variant="ligth" style="height: 24px;"
                          @click="comenzarEditar()"
                          :disabled="activar && nuevo"
                          v-if="$localStorageService.can('Confg_kits_nuevo')"
                ><em class="plusEdicion_svg"
                     v-b-tooltip.hover.lefttop.v-light
                     title="Crear nuevo kit"
                ></em>
                </b-button>
              </div>
            </div>

            <div style="overflow-y: scroll; height: 98%;">

              <div class="text-center" v-if="loadingKints">
                <b-spinner variant="info" />
              </div>

              <ListadoKits
                  v-else
                  :nuevoActivo="activar"
                  :nombreNuevoKit="nombreKit"
                  :arrayKitsProp="arrayKits"
                  @mostrarKit="mostrarKit"
                  :idKit="idKit"
              ></ListadoKits>
            </div>


          </b-card>
        </div>


        <div class="col-xl-8">
          <b-card class="bCardGlobalXL mt-3 ml-1" style="height: 42vw;">
            <div class="row">
              <div class="text-left textSixe col-6">
                <span style="color:#0069A9; font-weight: 500">Catálogo de kits dentales</span>
              </div>
            </div>
            <div v-show="!activar"
                style=" justify-content: center;align-content: center;display: grid; height: 66vh;"
            ><span>Sin Kits dental seleccionado</span>
            </div>


            <div v-show="activar" class="text-left" style="margin-top: 40px;">
              <div class="row">
                <div class="col-10">
                  <em v-if="nombreKit == null || nombreKit == ''"
                      class="kitInactivo_svg"></em>
                  <em v-else
                      class="kitActivo_svg"></em>
                  <span v-if="nombreKit == null || nombreKit == ''"
                      class="textSixe"
                        style="color: #B0B0B0; font-weight: 400; margin-left: 6px;"
                  > Nuevo kit dental</span>

                  <span v-else
                        class="textSixe"
                        style="color: #70C0C5; font-weight: 400; margin-left: 6px;"
                  > {{ nombreKit }}</span>
                </div>
                <div class="text-leftx textSixe col-2">
                  <em v-if="registroActivoKit && idKit != null"
                      class="trash_svg"
                      style="cursor:pointer;"
                      @click="inactivarKit(false)"
                      v-b-tooltip.hover.lefttop.v-light
                      title="Eliminar kit"
                  />
                  <em v-else-if="idKit != null"
                      class="activar_kit"
                      style="cursor:pointer; width: 22px"
                      @click="inactivarKit(true)"
                      v-b-tooltip.hover.lefttop.v-light
                      title="Activar kit"
                  />
                </div>
              </div>
              <div v-if="idKit !== null" class="mt-3 row" style="display: flex">
                <div class="col-md-4">
                  <span class="textSixe" style="color: #717171"> Usuario que creó: {{usuario}}</span>
                </div>
                <div class="col-md-4">
                  <span class="textSixe" style="color: #717171"> Fecha de creación: {{fechaAlta | formatoFecha}}</span>
                </div>
                <div class="col-md-4">
                  <span class="textSixe" style="color: #717171"> Fecha de mofificación: {{fechaModificacion | formatoFechaCorta}}</span>
                </div>

              </div>

              <div class="mt-3">

                <b-row>
                  <b-col cols="4">
                    <span class="textSixe">Nombre del kit </span>
                    <b-form-input
                        style=" border-radius: 11px;"
                        type="text"
                        placeholder="Nombre del nuevo combo dental"
                        v-model="nombreKit"
                        :state="nombreKit != null && nombreKit !== '' "
                    ></b-form-input>
                  </b-col>
                  <b-col cols="4">
                    <span class="textSixe">Imagen del kit </span>
                    <b-form-file
                        ref="imgKit"
                        v-model="imgKit"
                        :placeholder="nombreUrlImagen == null ? 'Ningún archivo seleccionado' : nombreUrlImagen"
                        drop-placeholder=" Ningún archivo seleccionado"
                        browse-text="Examinar"
                        icon="download"
                        accept=".jpg, .png"
                        @change="base64"
                    ></b-form-file>

                    <span v-if="imgKit == null" style=" color: red;font-size: 0.8em; ">Formatos permitidos: JPG, JPEG, PNG </span>
                    <span v-if="imgKit == null" style=" color: red;font-size: 0.8em; display: inline-block;">Tamaño permitido: 180 x 105 pixeles</span>
                  </b-col>
                  <b-col cols="4" v-if="imgKit !== null">
                    <div>
                      <span class="textSixe"> Vista Previa </span>
                      <em
                          class="trash_svg"
                          style="cursor:pointer; margin-left: 44%;"
                          @click="quitarImg()"
                      />
                    </div>
                    <div>
                      <img :src="'data:image/png;base64,' + imgKit " alt="img" style="height: 240px"/>
                    </div>



                  </b-col>
                </b-row>




<!--                <br/>-->
                <div class="row">
                  <div class="text-left textSixe col-6">
                    <span
                          style="color:#70C0C5; font-weight: 400"
                    >Tratamientos agredados al kit</span>
                  </div>
                  <div class="text-right textSixe col-6">
                    <b-button size="sm" pill variant="ligth" style="height: 24px;"
                              @click="agregarTratamientos()"
                              v-b-tooltip.hover.lefttop.v-light
                              title="Agregar nuevo tratamiento"
                              v-if="$localStorageService.can('Confg_kits_tx_kit')"
                    >
                      <em class="plusEdicion_svg"></em>
                    </b-button>

                  </div>
                </div>

              </div>


              <b-row style="width: 99%;">
                <b-col sm="9" md="9" lg="9" >
                  <span class="textSixe">Tratamiento</span>
                </b-col>
                <b-col sm="2" md="2" lg="2">
                  <span class="textSixe">Cantidad</span>
                </b-col>
                <b-col sm="1" md="1" lg="1"></b-col>
              </b-row>

              <hr style="margin-top: 1px;"/>
              <div class="inner">
                <b-row v-for="(trat, index) in idKit == null ? tratamientosAgregados : tratamientosKit" :key="'kt-'+index" style="width: 99%;">
                  <b-col sm="9" md="9" lg="9" >
                    <SelectTratamientos
                        style="width: 100%;"
                        :indexPadecimiento="1"
                        :indexOpcion="1"
                        :catalogoTratamientos="catTratamientos"
                        :idSeleccionado="trat.idTratamiento"
                        :tratamiento="trat"
                        :tratamientos="catTratamientos"
                        :i="index"
                    ></SelectTratamientos>
                  </b-col>

                  <b-col sm="2" md="2" lg="2">
                    <b-form-input
                        style="width: 60%;border-radius: 10px; height: 36px;margin-top: 12px;"
                        type="number"
                        min="1"
                        v-model.number="trat.cantidad"
                        @keydown="filterJustNumber($event)"
                        @input="soloNumeros($event)"
                        @keyup="validarCantidad(trat.cantidad, trat)"
                    ></b-form-input>
                  </b-col>

                  <b-col sm="1" md="1" lg="1"
                         class="text-left"
                  >
                    <em class="trash_svg"
                        style="margin-top: 14px; cursor:pointer;"
                        @click="eliminarTratamiento(index)"
                    ></em>
                  </b-col>

                </b-row>
              </div>

              <div class="text-center">
                <b-button v-if="registroActivoKit && $localStorageService.can('Confg_kits_guardar')"
                          variant="info"
                          pill
                          :disabled="(idKit == null && tratamientosAgregados.length <= 1 ) ||  ( idKit != null && tratamientosKit.length <= 1  )"
                          @click="guardar()"
                >
                  <span v-if="!spinner">Guardar</span>
                  <span v-if="spinner">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
                </b-button>
              </div>


            </div>





          </b-card>
        </div>
      </div>
  </div>


</template>

<script>
import Header from "@/components/Header";
import ListadoKits from "@/version5/kitsTratam/ListadoKits";
import SelectTratamientos from "@/version5/diagnostico/SelectTratamientos";
import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";
export default {
  name: "KitConfiguracion",
  components: {SelectTratamientos, ListadoKits, Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    ptiPrsuntivoServicio: new PtiPresuntivoService(),
    activar: false,
    spinner: false,
    nombreKit: null,
    tratamientosAgregados:[],
    catTratamientos: null,
    tratamientos: null,
    idKit: null,
    arrayKits: [],
    tratamientosKit: [],
    usuario: null,
    fechaAlta: null,
    fechaModificacion: null,
    nuevo: false,
    loadingKints: false,
    registroActivoKit: false,
    imgKit: null,
    nombreUrlImagen: null,
    tipoImagen: "",
    cambioImg: false
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerTratamientos();
  },
  methods: {
    selectFile(e){

      this.cambioImg = true;
      let base = e.target.files || e.dataTransfer.files;
      const file = new Blob([base[0]], { type: "image/png" });
      const extencionImagen = base[0].type.substr(6, 100);


      if(extencionImagen !== 'png' && extencionImagen !== 'jpg' && extencionImagen !== 'jpeg'){
        this.imgKit = null;
        this.$refs.imagenArgumentario.reset();
      }else {

        /* let img = new Image();*/
        this.tipoImagen = file.type;

        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (e) => {
          let imagen = e.target.result
          let indice = imagen.indexOf(",");
          let base64 = imagen.substring(indice+1, 100000000);
          this.imgKit = base64
        };
      }

    },
    base64(e) {
      let files = e.target.files || e.dataTransfer.files;

      const file = new Blob([files[0]], { type: "image/png" });

      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          if (img.width > 180 || img.height > 105) {

            this.imgKit = null;
            this.nombreUrlImagen = null;
            this.$swal({
              icon: "error",
              title: "La imagen excede del tamaño 180px x 105px",
              showConfirmButton: false,
              timer: 2500,
            });
          }else {

            this.selectFile(e);

          }
        };
        img.src = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
    quitarImg(){
      this.imgKit = null;
      this.cambioImg = true;

    },
    mostrarKit(kit){
      console.log(kit, "kit")
      this.activar = true;
      this.nuevo = false;
      this.nombreKit = kit.nombreKit;
      this.idKit = kit.idKit;
      this.tratamientosKit = kit.listaTratamientos;
      this.usuario = kit.usuarioModificacion;
      this.fechaAlta = kit.fechaAlta;
      this.fechaModificacion = kit.fechaModificacion;
      this.registroActivoKit = kit.registroActivoKit;
      this.imgKit = kit.imagenKit;
      this.nombreUrlImagen = kit.urlImagen != null ? kit.urlImagen.slice(4, 100) : null;
      this.cambioImg = false;
    },
    validarCantidad(cantidad, trat){
      if (cantidad > 24){
        trat.cantidad = 24
      }
    },
    cambiarEstatus(estatus){
      const params = {
        idKit: this.idKit
      }
      this.$http.post(this.$api + 'catalogo/kits/cambiarEstatus', params).then(respuesta => {
        if (respuesta.data.data){
          let mensaje = estatus ? 'Kit activado correctamente' : 'Kit desactivado correctamente'
          this.$swal({
            icon: "success",
            text: mensaje,
            showConfirmButton: false,
            timer: 2500,
          });
          this.registroActivoKit = !this.registroActivoKit
          this.listarKits();
        }else {
          this.$swal.fire({
            icon: "error",
            html: '<strong><span>No se puede activar este kit</span></strong> <br>' +
                ' <br> <h5 style="font-size: 12px;margin-bottom: -20px;"> Este kit cuenta con uno o más tratamientos desactivados. Por favor </h5> <br> ' +
                '<h5 style="font-size: 12px;"> activalos para poder activar este kit</h5>',
            showCancelButton: false,
            confirmButtonColor: "#8e8e8e",
            confirmButtonText: "Enterado",
          })
        }

      })
    },

     /* title: "Desactivar Kit",
    text: "Este kit ya no podrá ser usado en nuevos Ptis, ¿Desea continuar?",*/
    inactivarKit(estatus) {
      if (!estatus) {
        this.$swal.fire({
          icon: "info",
          html: '<strong><span>Desactivar Kit</span></strong> <br>' +
              ' <br> <h5 style="font-size: 12px;margin-bottom: -20px;"> Este kit ya no podrá ser usado en nuevos pti´s, ¿Desea </h5> <br> ' +
              '<h5 style="font-size: 12px;"> continuar ?</h5>',
          showCancelButton: true,
          confirmButtonColor: "#0e6ba9",
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          cancelButtonColor: "#8e8e8e",
        }).then((result) => {
          if (result.isConfirmed) {
           this.cambiarEstatus();
          }
        })
    } else {
        this.cambiarEstatus(estatus);
      }
    },
    guardar(){
      console.log(this.tratamientosAgregados, this.tratamientosKit, "****")
      let guardar = true;
      if (this.idKit == null ){
        this.tratamientosAgregados.forEach(ta => {
          if (ta.idTratamiento == null || ta.cantidad === 0){
            guardar = false;
          }
        })
      }
      if (this.idKit != null){
        this.tratamientosKit.forEach(tk => {
          if (tk.idTratamiento == null || tk.cantidad === 0){
            guardar = false;
          }
        })
      }

      if (this.nombreKit == null ){
        guardar = false;
      }

      if (guardar) {

        const params = {
          idKit: this.idKit,
          nombreKit: this.nombreKit,
          listaTratamientos: this.idKit == null ? this.tratamientosAgregados : this.tratamientosKit,
          imagenKit: this.imgKit,
          extencionImagen: this.tipoImagen,
          cambioImg: this.cambioImg
        }
        this.spinner = true;
        this.$http.post(this.$api + 'catalogo/kits/guardar', params).then(respuesta => {
          if (respuesta.data.data) {
            this.spinner = false;
            this.activar = false;
            this.nuevo = false;
            this.loadingKints = true;
            this.$swal({
              icon: "success",
              text: "Kit guardado correctamente",
              showConfirmButton: false,
              timer: 2500,
            });
            this.listarKits();
          }
        }).finally(() => {
          this.spinner = false;
        })
      }else {
        this.$swal({
          icon: "error",
          text: "Faltan datos para configurar el kit",
          confirmButtonText: "De acuerdo",
          confirmButtonColor: "#0e6ba9",
        });
      }
    },
    listarKits(){
      this.$http.post(this.$api + 'catalogo/kits/listarKits').then(respuesta => {
        if (respuesta.data.data) {
          this.arrayKits = respuesta.data.data;

          this.arrayKits.forEach(ak => {
            ak.listaTratamientos.forEach(lt => {
              lt.collapseOpen = false;
            })
          })
        }
      }).finally(() => {
        this.loadingKints = false;
      })
    },
    comenzarEditar(){
      this.activar = true;
      this.nuevo = true;
      this.idKit = null;
      this.nombreKit = null;
      this.registroActivoKit = true;
      this.tratamientosAgregados = [];
    },
    agregarTratamientos(){
      if (this.idKit !== null ){
        this.tratamientosKit.push({
          idTratamiento: null,
          cantidad: 1,
        })
      }else {
        this.tratamientosAgregados.push({
          idTratamiento: null,
          cantidad: 1,
        })
      }

    },
    eliminarTratamiento(index){
      if (this.idKit == null){
        this.tratamientosAgregados.splice(index, 1)
      }else {
        this.tratamientosKit.splice(index, 1)
      }

    },
    obtenerTratamientos() {
      this.loadingKints = true;
      const params= {
        idClinica: 0
      }
      this.ptiPrsuntivoServicio.obtenerTramientosPorClinica(params).then(
          response => {
            this.catTratamientos = response
          }
      ).catch((error) => {
        console.info(error)
        this.loadingKints = false;
      }).finally(() => {
        this.listarKits();
      })
    },

    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '.'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }
    },
    soloNumeros($event){
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
  },
}
</script>

<style scoped>
.textSixe{
  font-size: .7em;
}
.inner {
  height: 36vh;
  overflow-y: scroll;
/*  tyle="height: 215px; overflow-y: scroll"*/
}



</style>